import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import AreasTable from '../list/AreasTable';
import './styles.scss';

class LogisticAreas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'addArea': false,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.LogisticAreas,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.fetchLogisticAreasList();
  }

  addNewArea = () => {
    this.setState({'addArea': true});
  };

  cancelAddArea = () => {
    this.setState({'addArea': false});
  }

  renderLoaderOrServices = () => {
    const {loading, list, loadingDetail} = this.props;
    const {addArea} = this.state;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return <AreasTable list={list} addArea={addArea}
      loadingDetail={loadingDetail} cancelAddArea={this.cancelAddArea} />;
  };

  render() {
    return (
      <div className="logistic-area-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Mantenimiento de Áreas de Logística</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  className="toyota-primary"
                  onClick={this.addNewArea}
                >
                  Añadir nueva área
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="logistic-area-table">
          {this.renderLoaderOrServices()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.logisticServices.list,
    'loading': state.logisticServices.loading,
    'loadingDetail': state.logisticServices.loadingDetail,
  };
};

const {fetchLogisticAreasList, navigateTo} = Actions;

const mapDispatchToProps = {
  fetchLogisticAreasList,
  navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogisticAreas);
